import React, { useEffect, useState } from 'react'
import { Breadcrumb } from 'react-bootstrap'
import Card from '../../../UI/Card/Card'
import Graybg from '../../../UI/Graybg'
import SearchInput from '../../../UI/SearchInput/SearchInput'
import SecBTN from '../../../UI/SecBTN'
import Select from '../../../UI/Select/Select'
import classes from './SearchQuestion.module.css'
import userService from '../../../app/services/user.service'
import Loader from '../../../UI/loader/loader'
import { isEmpty, linkReplaceFn } from '../../../utils/custom_funtions'
import Toast from '../../../UI/Toast/Toast'
import { toast } from 'react-toastify'

const SearchQuestion = () => {
  // const [selectedSubject,setSelectedSubject] = useState('');
  // const [searchText,setSearchText] = useState('');
  // const [subjectList,setSubjectList] = useState([]);
  // const [pageNo,setPageNo] = useState(1);
  const [state, setState] = useState({
    selectedSubject: '',
    searchText: '',
    subjectList: [],
    pageNo: 1,
    searchedQuestionList: [],
    isLoading: false,
    isError: false,
    errMsg: '',
  });

  useEffect(() => {
    userService.getSubjectList()
      .then(res => {
        console.log(res.data.data)
        setState(prev => {
          return { ...prev, subjectList: res.data.data }
        })
      })
      .catch(err => {
        console.log(err)
      })
  }, [])
  const searchHandler = (pageNo) => {
    setState(prev => ({
      ...prev,
      isLoading: true,
      isError: false,
      errMsg: "",
      searchedQuestionList: [], // Clear previous data
    }));

    const body = {
      search: state.searchText,
      subid: state.selectedSubject,
      page: pageNo,
    };

    userService.getSearchedQuestions(body)
      .then((res) => {
        const questionData = res.data.data || [];

        // No data found
        if (isEmpty(questionData[0])) {
          if (pageNo > 1) {
            toast.error("No more questions found !!");
          }

          setState(prev => ({
            ...prev,
            isLoading: false,
            isError: true,
            errMsg:
              pageNo > 1
                ? "No more questions found !!"
                : "No Question found !!",
            searchedQuestionList: [],
          }));

          return;
        }

        setState(prev => ({
          ...prev,
          isLoading: false,
          isError: false,
          errMsg: "",
          searchedQuestionList: questionData.map((data) => ({
            ...data,
            eng_option: linkReplaceFn(data.eng_option),
            q_text: linkReplaceFn(data.q_text),
          })),
        }));
      })
      .catch((err) => {
        setState(prev => ({
          ...prev,
          isLoading: false,
          isError: true,
          errMsg: err.response?.data?.message || "Something went wrong",
          searchedQuestionList: [], // Clear previous data on error
        }));

        console.log(err);
      });
  };
  useEffect(() => {
    console.log("page no.", state.pageNo)

  }, [state.pageNo])

  return (
    <>
      <Toast />
      {state.isLoading && <Loader />}
      <div className="section">
        <h4>Search Question</h4>
        <Breadcrumb>
          <Breadcrumb.Item>Question</Breadcrumb.Item>
          <Breadcrumb.Item active>Search Question</Breadcrumb.Item>
        </Breadcrumb>
        <Graybg>
          <Card>
            <p>Subject:</p>
            <Select
              className="my-2"
              value={state.selectedSubject}
              onChange={(e) => {
                setState((prev) => {
                  return { ...prev, pageNo: 1, selectedSubject: e.target.value };
                });
              }}
            >
              <option value="" disabled>
                Select Subject
              </option>
              {state.subjectList.map((subject) => {
                return (
                  <option key={subject.sub_id} value={subject.sub_id}>
                    {subject.sub_name}
                  </option>
                );
              })}
              {/* <option value=''>Physics</option>
                <option value=''>Chemistry</option>
                <option value=''>Maths</option> */}
            </Select>
            <SearchInput
              className={"border border-secondary"}
              placeholder="Permutations and combinations"
              value={state.searchText}
              onChange={(e) => {
                setState((prev) => {
                  return { ...prev, pageNo: 1, searchText: e.target.value };
                });
              }}
            />
            <div className="text-center mt-4">
              <SecBTN
                className="sec-btn1"
                disabled={
                  isEmpty(state.searchText) || isEmpty(state.selectedSubject)
                }
                onClick={() => searchHandler(state.pageNo)}
              >
                Search
              </SecBTN>
            </div>
          </Card>
          {/* <DataTable /> */}
          {!isEmpty(state.searchedQuestionList) ? (
            <>
              <p className="mb-2">
                Showing <b>{state.searchedQuestionList.length}</b> entries
              </p>
              <div className="table-responsive mb-3">
                <table className="table table-bordered mt-2 mb-0">
                  <thead className={classes.tblheader}>
                    <tr>
                      <th>No.</th>
                      <th>QID</th>
                      <th>Question</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.searchedQuestionList.map((question, index) => (
                      <tr key={question.qid}>
                        <td>{index + 1}</td>
                        <td>{question.qid}</td>
                        <td>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: question.q_text,
                            }}
                          />

                          <ol
                            type="A"
                            style={{
                              marginLeft: "25px",
                            }}
                          >
                            {question.eng_option
                              ?.split("@@@")
                              .filter(option => option.trim() !== "")
                              .slice(0, 4)
                              .map((option, idx) => (
                                <li key={idx}>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: option,
                                    }}
                                  />
                                </li>
                              ))}
                          </ol>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/*} Backend change required for Pagination */}
              {/* <div className='d-flex justify-content-between'>
                <SecBTN className="sec-btn1" disabled={state.pageNo === 1} onClick={() => {
                  setState(prev => {
                    return { ...prev, pageNo: prev.pageNo - 1 }
                  })
                  searchHandler(state.pageNo - 1)
                }}>Prev</SecBTN>
                <SecBTN className="sec-btn1" onClick={() => {
                  setState(prev => {
                    return { ...prev, pageNo: prev.pageNo + 1 }
                  })
                  searchHandler(state.pageNo + 1)
                }}>Next</SecBTN>
              </div> */}
            </>
          ) : state.isError ? (
            <p className="text-center text-danger">{state.errMsg}</p>
          ) : (
            ""
          )}
        </Graybg>
      </div>
    </>
  );
}

export default SearchQuestion
